export default __webpack_public_path__ + "static/media/home_back.e78d0d93.png";